import { render } from "./AuraProcessingCostsSort.vue?vue&type=template&id=9345aa28&ts=true"
import script from "./AuraProcessingCostsSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCostsSort.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraProcessingCostsSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9345aa28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9345aa28', __exports__)) {
    api.reload('9345aa28', __exports__)
  }
  
  module.hot.accept("./AuraProcessingCostsSort.vue?vue&type=template&id=9345aa28&ts=true", () => {
    api.rerender('9345aa28', render)
  })

}


export default __exports__